<template>
    <div>
        <v-dialog v-model="dialog" width="500px">
            <v-card>
                <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
                <br>
                <v-card-text>Are you sure you want the remove change {{ change_key }} and all of it's history?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="warning mx-2" small v-on:click="rmHowz">Yes</v-btn>
                    <v-btn color="success" small @click="dialog = false">No</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogAll" width="500px">
            <v-card>
                <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
                <br>
                <v-card-text>Are you sure you want the remove change "{{ change_key }}" and all of it's history from <b>all</b> bookings?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="warning mx-2" small v-on:click="rmHowzAll">Yes</v-btn>
                    <v-btn color="success" small @click="closeAll">No</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        props: {
            huov_encrid: String,
        },
        data() {
            return {
                dialog: false,
                dialogAll: false,
                howz_encrid: '',
                change_key: '',
            }
        },
        methods: {
            open(howz_encrid, change_key) {
                this.howz_encrid = howz_encrid;
                this.change_key = change_key;
                this.dialog = true;
            },
            rmHowz() {
                this.$axios
                    .post("ares/json/ares/huov/howz/rmHowz.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "rmHowz"
                        },
                        rmHowz: {
                            howz_encrid: this.howz_encrid
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            this.$emit('updateField', {field: 'showDetails', value: false});
                            this.$emit('updateData', 'refresh');
                            this.dialog = false;
                        }
                    })
            },
            openAll(howz_encrid, change_key) {
                this.howz_encrid = howz_encrid;
                this.change_key = change_key;
                this.dialogAll = true;
            },
            rmHowzAll() {
                this.$axios
                    .post("ares/json/ares/huov/howz/rmHowzAll.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "rmHowzAll"
                        },
                        rmHowzAll: {
                            howz_encrid: this.howz_encrid
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            this.$emit('updateField', {field: 'showSelectHowz', value: true});
                            this.$emit('updateData', 'update_howz');
                            this.dialogAll = false;
                        }
                    })
            },
            closeAll() {
                this.$emit('updateField', {field: 'showSelectHowz', value: true});
                this.$emit('updateData', 'update_howz');
                this.dialogAll = false;
            },
        }
    }
</script>

